import { useComponentsManager, useComponents, useComponent } from '@panneau/core/contexts';
export { ComponentsProvider, FIELDS_NAMESPACE, useFieldComponent, useFieldsComponentsManager } from '@panneau/core/contexts';
import PropTypes from 'prop-types';
import React, { useContext, useMemo } from 'react';

var EDITORS_NAMESPACE = 'editors';
var VIEWERS_NAMESPACE = 'viewers';
var COMPONENTS_NAMESPACE = 'components';
var BLOCKS_NAMESPACE = 'blocks';
var HEADERS_NAMESPACE = 'headers';
var PICKERS_NAMESPACE = 'pickers';
var MODALS_NAMESPACE = 'modals';

/**
 * Editors hooks
 */
var useEditorsComponentsManager = function useEditorsComponentsManager() {
  return useComponentsManager(EDITORS_NAMESPACE);
};
var useEditorsComponents = function useEditorsComponents() {
  var defaultComponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return useComponents(EDITORS_NAMESPACE, defaultComponents);
};
var useEditorComponent = function useEditorComponent(name) {
  var defaultComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return useComponent(name, defaultComponent, EDITORS_NAMESPACE);
};

/**
 * Viewers hooks
 */
var useViewersComponentsManager = function useViewersComponentsManager() {
  return useComponentsManager(VIEWERS_NAMESPACE);
};
var useViewersComponents = function useViewersComponents() {
  var defaultComponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return useComponents(VIEWERS_NAMESPACE, defaultComponents);
};
var useViewerComponent = function useViewerComponent(name) {
  var defaultComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return useComponent(name, defaultComponent, VIEWERS_NAMESPACE);
};

/**
 * Components hooks
 */
var useDocumentComponentsManager = function useDocumentComponentsManager() {
  return useComponentsManager(COMPONENTS_NAMESPACE);
};
var useDocumentComponents = function useDocumentComponents() {
  var defaultComponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return useComponents(COMPONENTS_NAMESPACE, defaultComponents);
};
var useDocumentComponent = function useDocumentComponent(name) {
  var defaultComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return useComponent(name, defaultComponent, COMPONENTS_NAMESPACE);
};

/**
 * Blocks hooks
 */
var useBlocksComponentsManager = function useBlocksComponentsManager() {
  return useComponentsManager(BLOCKS_NAMESPACE);
};
var useBlocksComponents = function useBlocksComponents() {
  var defaultComponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return useComponents(BLOCKS_NAMESPACE, defaultComponents);
};
var useBlockComponent = function useBlockComponent(name) {
  var defaultComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return useComponent(name, defaultComponent, BLOCKS_NAMESPACE);
};

/**
 * Headers hooks
 */
var useHeadersComponentsManager = function useHeadersComponentsManager() {
  return useComponentsManager(HEADERS_NAMESPACE);
};
var useHeadersComponents = function useHeadersComponents() {
  var defaultComponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return useComponents(HEADERS_NAMESPACE, defaultComponents);
};
var useHeaderComponent = function useHeaderComponent(name) {
  var defaultComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return useComponent(name, defaultComponent, HEADERS_NAMESPACE);
};

/**
 * Pickers hooks
 */
var usePickersComponentsManager = function usePickersComponentsManager() {
  return useComponentsManager(PICKERS_NAMESPACE);
};
var usePickersComponents = function usePickersComponents() {
  var defaultComponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return useComponents(PICKERS_NAMESPACE, defaultComponents);
};
var usePickerComponent = function usePickerComponent(name) {
  var defaultComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return useComponent(name, defaultComponent, PICKERS_NAMESPACE);
};

/**
 * Modals hooks
 */
var useModalsComponentsManager = function useModalsComponentsManager() {
  return useComponentsManager(MODALS_NAMESPACE);
};
var useModalsComponents = function useModalsComponents() {
  var defaultComponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return useComponents(MODALS_NAMESPACE, defaultComponents);
};
var useModalComponent = function useModalComponent(name) {
  var defaultComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return useComponent(name, defaultComponent, MODALS_NAMESPACE);
};

var EditorContext = /*#__PURE__*/React.createContext(null);


var useEditor = function useEditor() {
  return useContext(EditorContext);
};

/* #__NO_SIDE_EFFECTS__ */
function useIsEditor() {
  {
    return false;
  }
}

/* #__NO_SIDE_EFFECTS__ */
function useEditorPlatform() {
  {
    return null;
  }
}
var propTypes = {
  platform: PropTypes.shape({}),
  children: PropTypes.node.isRequired
};
var defaultProps = {
  platform: null
};


var EditorProvider = function EditorProvider(_ref2) {
  var platform = _ref2.platform,
    children = _ref2.children;
  var value = useMemo(function () {
    return {
      platform: platform
    };
  }, [platform]);
  return /*#__PURE__*/React.createElement(EditorContext.Provider, {
    value: value
  }, children);
};
EditorProvider.propTypes = propTypes;
EditorProvider.defaultProps = defaultProps;

export { BLOCKS_NAMESPACE, COMPONENTS_NAMESPACE, EDITORS_NAMESPACE, EditorContext, EditorProvider, HEADERS_NAMESPACE, MODALS_NAMESPACE, PICKERS_NAMESPACE, VIEWERS_NAMESPACE, useBlockComponent, useBlocksComponents, useBlocksComponentsManager, useDocumentComponent, useDocumentComponents, useDocumentComponentsManager, useEditor, useEditorComponent, useEditorPlatform, useEditorsComponents, useEditorsComponentsManager, useHeaderComponent, useHeadersComponents, useHeadersComponentsManager, useIsEditor, useModalComponent, useModalsComponents, useModalsComponentsManager, usePickerComponent, usePickersComponents, usePickersComponentsManager, useViewerComponent, useViewersComponents, useViewersComponentsManager };
